/*
 * Collapse long product descriptions behind a Read more button.
 *
 * Across the 561 products in this store the description runs 429 characters at
 * the median but 1128 at the 90th percentile, and most of them are written one
 * <p> per bullet line, so a long one turns into a wall of text that pushes the
 * reviews and related products far down the page. Clamping normalises that
 * without hiding anything: the full text stays in the DOM for search engines
 * and one tap opens it.
 */
(function () {
  // Tuned against the real catalogue: the median description renders around
  // 200px tall, so this leaves short ones alone and catches the long lists.
  var MAX_DESKTOP = 220;
  var MAX_MOBILE = 200;

  // Only clamp when there is enough hidden to be worth a button. Collapsing a
  // description that is 20px too tall just costs the visitor a click.
  var SLACK = 60;

  var LABEL_MORE = 'Read more';
  var LABEL_LESS = 'Read less';

  function maxHeight() {
    return window.matchMedia('(max-width: 749px)').matches ? MAX_MOBILE : MAX_DESKTOP;
  }

  function buildToggle(desc) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'gf-desc-toggle';
    button.setAttribute('aria-expanded', 'false');

    var label = document.createElement('span');
    label.className = 'gf-desc-toggle__label';
    label.textContent = LABEL_MORE;

    var chevron = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    chevron.setAttribute('viewBox', '0 0 24 24');
    chevron.setAttribute('aria-hidden', 'true');
    chevron.setAttribute('focusable', 'false');
    chevron.classList.add('gf-desc-toggle__icon');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'm6.5 9.5 5.5 5.5 5.5-5.5');
    chevron.appendChild(path);

    button.appendChild(label);
    button.appendChild(chevron);

    if (desc.id === '') desc.id = 'GfDesc-' + Math.round(performance.now());
    button.setAttribute('aria-controls', desc.id);

    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        desc.classList.add('gf-desc--clamped');
        desc.style.maxHeight = maxHeight() + 'px';
        button.setAttribute('aria-expanded', 'false');
        label.textContent = LABEL_MORE;
        // Scrolling back up matters here: collapsing a tall description can
        // otherwise leave the reader stranded further down the page.
        var top = desc.getBoundingClientRect().top;
        if (top < 0) desc.scrollIntoView({ block: 'start', behavior: 'smooth' });
      } else {
        desc.classList.remove('gf-desc--clamped');
        desc.style.maxHeight = '';
        button.setAttribute('aria-expanded', 'true');
        label.textContent = LABEL_LESS;
      }
    });

    return button;
  }

  function apply(desc) {
    var button = desc.gfToggle;
    var expanded = button && button.getAttribute('aria-expanded') === 'true';
    if (expanded) return;

    // Measure unclamped, otherwise scrollHeight just reports the clamp.
    desc.classList.remove('gf-desc--clamped');
    desc.style.maxHeight = '';

    var max = maxHeight();
    var natural = desc.scrollHeight;

    if (natural <= max + SLACK) {
      if (button) button.hidden = true;
      return;
    }

    desc.classList.add('gf-desc--clamped');
    desc.style.maxHeight = max + 'px';

    if (!button) {
      button = buildToggle(desc);
      desc.gfToggle = button;
      desc.insertAdjacentElement('afterend', button);
    }
    button.hidden = false;
  }

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('.product__description');
    Array.prototype.forEach.call(nodes, function (desc) {
      // Quick-add drawers render their own copy; leave those alone.
      if (desc.closest('quick-add-modal')) return;
      apply(desc);
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    init();

    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        init();
      }, 200);
    });

    // Images inside a description change its height once they load.
    window.addEventListener('load', function () {
      init();
    });

    // The theme editor re-renders sections in place.
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  });
})();
